<template>
  <Dropdown
    v-model="localValue"
    label="Sort by"
    :options="options"
    :disabled="isLoading"
    @change="emit('sort', $event?.target?.value)"
  />
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue';

const Dropdown = defineAsyncComponent(() => import('@common-vue/atomic-ui/src/components/dropdown/Dropdown'));

const props = defineProps({
  options: {
    type: Array,
    required: false,
    default: () => ([]),
  },
  value: {
    type: String,
    required: false,
  },
  isLoading: {
    type: Boolean,
    required: false,
  },
});

const localValue = computed(() => props.value);
const emit = defineEmits(['sort']);

</script>
